export { default as UserSubtractSolidIcon } from './UserSubtractSolidIcon';
